import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { hero } from "../mock";

export default function Hero() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = () => {
    const el = document.getElementById("philosophy");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const fade = Math.max(0, 1 - scrollY / 500);

  return (
    <section id="hero" className="relative h-screen min-h-[560px] w-full overflow-hidden">
      <div className="absolute inset-0" style={{ transform: `translateY(${scrollY * 0.3}px)` }}>
        <img
          src={hero.bg}
          alt="Luxury estate living room with travertine fireplace"
          className="h-[118%] w-full object-cover"
        />
      </div>

      <div className="absolute inset-0 bg-black/25" />
      <div className="absolute inset-x-0 top-0 h-52 bg-gradient-to-b from-black/55 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-52 bg-gradient-to-t from-black/35 to-transparent" />

      <div
        className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center -translate-y-4"
        style={{ opacity: fade }}
      >
        <p
          className="whitespace-nowrap font-sans text-[11px] uppercase tracking-[0.3em] text-white/95 opacity-0 animate-[fadeUp_1s_forwards] sm:text-sm sm:tracking-[0.45em]"
          style={{ animationDelay: "0.35s" }}
        >
          {hero.kicker}
        </p>

        <div className="mt-3 overflow-hidden py-1 sm:mt-4">
          <h1
            className="whitespace-nowrap font-sans text-3xl font-light uppercase tracking-[0.18em] text-white opacity-0 animate-[maskUp_1.3s_cubic-bezier(0.22,1,0.36,1)_forwards] sm:text-5xl sm:tracking-[0.22em] lg:text-6xl"
            style={{ animationDelay: "0.55s" }}
          >
            {hero.title}
          </h1>
        </div>

        <button
          onClick={go}
          className="group mt-3 flex items-center gap-3 border border-white/30 bg-white/10 px-8 py-3.5 font-sans text-[11px] uppercase tracking-[0.3em] text-[#F1E6D7] backdrop-blur-md transition-all duration-500 hover:border-white/50 hover:bg-white/20 opacity-0 animate-[fadeUp_1s_forwards]"
          style={{ animationDelay: "1.15s" }}
        >
          {hero.cta}
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2" style={{ opacity: fade }}>
        <div className="opacity-0 animate-[fadeUp_1s_forwards]" style={{ animationDelay: "1.6s" }}>
          <div className="h-14 w-px bg-gradient-to-b from-white/70 to-transparent animate-[scrollPulse_2.4s_ease-in-out_infinite]" />
        </div>
      </div>

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes maskUp { from { opacity: 0; transform: translateY(100%); } to { opacity: 1; transform: translateY(0); } }
        @keyframes scrollPulse { 0%,100% { opacity: 0.25; transform: scaleY(0.6); transform-origin: top; } 50% { opacity: 1; transform: scaleY(1); } }
      `}</style>
    </section>
  );
}
